module.exports = __webpack_public_path__ + "img/goal-thirteen-en.8b5de418.png";